import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Box,
  TextField,
  MenuItem,
  Switch,
  FormControlLabel,
  Grid,
  Checkbox,
  FormControl,
  RadioGroup,
  Radio,
  FormGroup,
} from "@mui/material";
import Buttons from "../../../components/Controls/Buttons/Button";
import BackButtons from "../../../components/Controls/Buttons/BackArrowButton";
import Label from "../../../components/Label/Label";
import {
  boxCoxOptions,
  limitMethods,
  rules,
  specLimits,
  stdevMethods,
} from "./constants";

const DefinitionPopup = ({
  open,
  onClose,
  definationTabField,
  errors,
  onChange,
  handleSubmit,
  viewData,
  analyticsTabField,
  handleAnalyticsTabValueChange,
  handleRuleToggle,
  alertTabFields,
  setAlertTabFields,
}) => {
  const [isEdit, setIsEdit] = React.useState(false);
  const [fieldType, setFieldType] = React.useState("defination");

  const handleClose = () => {
    setIsEdit(false);
    onClose();
  };

  const labelStyle = {
    top: "-6px",
    fontSize: "14px",
    backgroundColor: "#fff",
    padding: "0 4px",
  };

  const renderDefinationField = () => (
    <Box display="flex" flexDirection="column" gap={1}>
      <TextField
        size="small"
        label="Parameter Name"
        variant="outlined"
        fullWidth
        name="parameterName"
        value={definationTabField?.parameterName}
        onChange={onChange}
        error={!!errors?.parameterName}
        helperText={errors?.parameterName}
      />
      <TextField
        size="small"
        label="Description"
        variant="outlined"
        fullWidth
        multiline
        name="description"
        value={definationTabField?.description}
        onChange={onChange}
        error={!!errors?.description}
        helperText={errors?.description}
        minRows={2}
      />
      <TextField
        size="small"
        select
        label="Parameter Source"
        variant="outlined"
        fullWidth
        name="parameterSource"
        value={definationTabField?.parameterSource}
        onChange={onChange}
        error={!!errors?.parameterSource}
        helperText={errors?.parameterSource}
        // InputLabelProps={{ style: labelStyle }}
      >
        {/* <MenuItem value="">Select Source</MenuItem> */}
        <MenuItem value="data-entry">Data Entry</MenuItem>
        <MenuItem value="Limits-only">Limits Only</MenuItem>
        <MenuItem value="derived">Derived</MenuItem>
      </TextField>
      <TextField
        size="small"
        select
        label="Unit of Measurement"
        variant="outlined"
        fullWidth
        name="unit"
        value={definationTabField?.unit}
        onChange={onChange}
        error={!!errors?.unit}
        helperText={errors?.unit}
        // InputLabelProps={{ style: labelStyle }}
      >
        <MenuItem value="">Select Unit</MenuItem>
        <MenuItem value="26">°</MenuItem>
        <MenuItem value="1">%</MenuItem>
        <MenuItem value="27">APHA</MenuItem>
        <MenuItem value="25">area%</MenuItem>
        <MenuItem value="3">bar</MenuItem>
        <MenuItem value="86">Bottles</MenuItem>
        <MenuItem value="4">°C</MenuItem>
        <MenuItem value="28">cartons</MenuItem>
        <MenuItem value="29">CFU/100mL</MenuItem>
        <MenuItem value="95">CFU/10mL</MenuItem>
        <MenuItem value="92">CFU/200mL</MenuItem>
        <MenuItem value="87">CFU/20mL</MenuItem>
        <MenuItem value="30">CFU/30mL</MenuItem>
        <MenuItem value="88">CFU/50mL</MenuItem>
        <MenuItem value="5">CFU/g</MenuItem>
        <MenuItem value="6">CFU/mL</MenuItem>
        <MenuItem value="31">Count AQL rejects</MenuItem>
      </TextField>
      <TextField
        size="small"
        select
        label="Data Type"
        variant="outlined"
        fullWidth
        name="dataType"
        value={definationTabField?.dataType}
        onChange={onChange}
        error={!!errors?.dataType}
        helperText={errors?.dataType}
        // InputLabelProps={{ style: labelStyle }}
      >
        <MenuItem value="text">Text</MenuItem>
        <MenuItem value="textnum">TextNum</MenuItem>
        <MenuItem value="datetime">Date/Time</MenuItem>
        <MenuItem value="date">Date</MenuItem>
      </TextField>
      <TextField
        size="small"
        select
        label="Status"
        variant="outlined"
        fullWidth
        name="status"
        value={definationTabField?.status}
        onChange={onChange}
        error={!!errors?.status}
        helperText={errors?.status}
        // InputLabelProps={{ style: labelStyle }}
      >
        <MenuItem value="active">Active</MenuItem>
        <MenuItem value="inactive">Inactive</MenuItem>
      </TextField>
      <TextField
        size="small"
        select
        label="Parameter Class"
        variant="outlined"
        fullWidth
        name="parameterClass"
        value={definationTabField?.parameterClass}
        onChange={onChange}
        error={!!errors?.parameterClass}
        helperText={errors?.parameterClass}
        // InputLabelProps={{ style: labelStyle }}
      >
        <MenuItem value="">Select Class</MenuItem>
        <MenuItem value="2">CPP</MenuItem>
        <MenuItem value="3">CQA</MenuItem>
        <MenuItem value="8">IPC</MenuItem>
        <MenuItem value="5">KPA</MenuItem>
        <MenuItem value="6">KPP</MenuItem>
        <MenuItem value="10">MetaD</MenuItem>
        <MenuItem value="11">Model</MenuItem>
        <MenuItem value="16">PP</MenuItem>
        <MenuItem value="21">QA</MenuItem>
        <MenuItem value="4">xGPP</MenuItem>
        <MenuItem value="9">xIPM</MenuItem>
        <MenuItem value="13">xnCPP</MenuItem>
        <MenuItem value="19">xnCQA</MenuItem>
        <MenuItem value="14">xnKPP</MenuItem>
        <MenuItem value="18">xPOI</MenuItem>
        <MenuItem value="20">xPrP</MenuItem>
      </TextField>
    </Box>
  );

  const renderAnalyticsField = () => (
    <Box display="flex" flexDirection="column" gap={1}>
      <TextField
        size="small"
        select
        label="Individuals Chart Ruleset"
        name="rulesetId"
        fullWidth
        value={analyticsTabField.rulesetId}
        onChange={handleAnalyticsTabValueChange}
        margin="normal"
        sx={{ p: 0, m: 0 }}
      >
        <MenuItem value="">Choose a ruleset</MenuItem>
        <MenuItem value="2">Nelson</MenuItem>
      </TextField>

      {analyticsTabField.rulesetId === "2" &&
        rules.map((rule) => (
          <Box key={rule.id} sx={{ mb: 1 }}>
            <Label variant="subtitle2" text={rule.label}></Label>
            <Label variant="body2" text={rule.desc}></Label>
            <Switch
              checked={analyticsTabField.runRules.includes(rule.id)}
              onChange={() => handleRuleToggle(rule.id)}
            />
          </Box>
        ))}

      <Box mt={1}>
        <Label text="MR Chart" />
        <FormControlLabel
          control={
            <Switch
              checked={analyticsTabField.useRuleOne}
              onChange={handleAnalyticsTabValueChange}
              name="useRuleOne"
            />
          }
          label="1 point above/below the control limits"
        />
      </Box>

      <TextField
        size="small"
        select
        label="Limit Method"
        name="limitMethod"
        fullWidth
        value={analyticsTabField.limitMethod}
        onChange={handleAnalyticsTabValueChange}
      >
        <MenuItem value="">Select</MenuItem>
        {limitMethods.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        size="small"
        select
        label="Standard Deviation Method"
        name="stdevMethod"
        fullWidth
        value={analyticsTabField.stdevMethod}
        onChange={handleAnalyticsTabValueChange}
      >
        <MenuItem value="">Select</MenuItem>
        {stdevMethods.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        size="small"
        select
        label="Box-Cox Transformation"
        name="boxCoxTransform"
        fullWidth
        value={analyticsTabField.boxCoxTransform}
        onChange={handleAnalyticsTabValueChange}
      >
        {boxCoxOptions.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </TextField>

      {analyticsTabField.boxCoxTransform === "lambda_specified" && (
        <TextField
          size="small"
          label="User Specified λ Value"
          name="boxCoxValue"
          value={analyticsTabField.boxCoxValue}
          onChange={handleAnalyticsTabValueChange}
          fullWidth
        />
      )}

      {/* <Grid container spacing={2}> */}
      {[1, 2, 3].map((num) => (
        // <Grid item xs={12} md={4} key={num}>
        <TextField
          size="small"
          select
          fullWidth
          label={`Specification Limit ${num}`}
          name={`spec${num}`}
          value={analyticsTabField[`spec${num}`]}
          onChange={handleAnalyticsTabValueChange}
        >
          <MenuItem value="">Select</MenuItem>
          {specLimits.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </TextField>
        // </Grid>
      ))}
      {/* </Grid> */}

      <TextField
        size="small"
        label="Min Y Axis Range"
        name="minYAxisRange"
        value={analyticsTabField.minYAxisRange}
        onChange={handleAnalyticsTabValueChange}
        fullWidth
      />

      <TextField
        size="small"
        label="Max Y Axis Range"
        name="maxYAxisRange"
        value={analyticsTabField.maxYAxisRange}
        onChange={handleAnalyticsTabValueChange}
        fullWidth
      />

      <TextField
        size="small"
        label="Display Alias"
        name="displayAlias"
        value={analyticsTabField.displayAlias}
        onChange={handleAnalyticsTabValueChange}
        fullWidth
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={analyticsTabField.useScientificNotation}
            onChange={handleAnalyticsTabValueChange}
            name="useScientificNotation"
          />
        }
        label="Use Scientific Notation"
      />
    </Box>
  );

  const renderAlertFields = () => {
    return (
      <>
        {/* Active Alerts Switch */}
        <Box display="flex" alignItems="center" gap={2} mb={2}>
          <Label text="Active Alerts" />
          <FormControlLabel
            control={
              <Switch
                checked={alertTabFields.activeAlerts}
                onChange={(e) =>
                  setAlertTabFields((prev) => ({
                    ...prev,
                    activeAlerts: e.target.checked,
                  }))
                }
                name="active_alerts"
                id="active_alerts"
              />
            }
            label=""
          />
        </Box>

        {/* Alert Fields - toggled based on activeAlerts */}
        <Box
          className="alert-fields"
          sx={{
            opacity: alertTabFields.activeAlerts ? 1 : 0.5,
            pointerEvents: alertTabFields.activeAlerts ? "auto" : "none",
          }}
        >
          {/* Chart Type Radio */}
          <FormControl component="fieldset" sx={{ mb: 2 }}>
            <Label text="Chart Type" />
            <RadioGroup
              row
              value={alertTabFields.subChartType || ""}
              onChange={(e) =>
                setAlertTabFields((prev) => ({
                  ...prev,
                  subChartType: e.target.value,
                }))
              }
              name="sub_chart_type"
            >
              <FormControlLabel
                value="individual"
                control={<Radio size="small" />}
                label="Individuals"
              />
              <FormControlLabel
                value="individual_moving_range"
                control={<Radio size="small" />}
                label="I-MR"
              />
            </RadioGroup>
          </FormControl>

          {/* Batch Range */}
          <Box sx={{ mb: 2 }}>
            <Label text="Batch Range" />
            <Box display="flex" alignItems="center" gap={1} mt={1}>
              <Label text="Last" />
              <TextField
                size="small"
                type="text"
                value={alertTabFields.batchLastN || ""}
                onChange={(e) =>
                  setAlertTabFields((prev) => ({
                    ...prev,
                    batchLastN: e.target.value,
                  }))
                }
                name="batch_last_n"
              />
              <Label text="Batches" />
            </Box>
          </Box>

          {/* Organize By Checkbox */}
          <FormControl component="fieldset">
            <Label text="Organize by" />
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={alertTabFields.organizeBy || false}
                    onChange={(e) =>
                      setAlertTabFields((prev) => ({
                        ...prev,
                        organizeBy: e.target.checked,
                      }))
                    }
                    name="organize_by"
                  />
                }
                label="Option 1"
              />
            </FormGroup>
          </FormControl>
        </Box>
      </>
    );
  };

  const renderViewTable = () => (
    <Table
      size="small"
      sx={{ "& .MuiTableCell-root": { borderBottom: "none" } }}
    >
      <TableBody>
        <TableRow>
          <TableCell sx={{ fontWeight: "bold", width: "40%" }}>
            Parameter Name
          </TableCell>
          <TableCell>{viewData?.parameter_name }</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "bold" }}>Description</TableCell>
          <TableCell>{viewData?.parameter_description }</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "bold" }}>Parameter ID</TableCell>
          <TableCell>{viewData?.parameter_id }</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "bold" }}>Review Status</TableCell>
          <TableCell>{viewData?.review_status }</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "bold" }}>Parameter Source</TableCell>
          <TableCell>{viewData?.source_system }</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "bold" }}>Unit of Measure</TableCell>
          <TableCell>{viewData?.unit_of_measure }</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "bold" }}>Data Type</TableCell>
          <TableCell>{viewData?.datatype }</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "bold" }}>Active Status</TableCell>
          <TableCell>{viewData?.status }</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "bold" }}>Parameter Class</TableCell>
          <TableCell>{viewData?.parameter_class }</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "bold" }}>Query Alias</TableCell>
          <TableCell>{viewData?.alias }</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "bold" }}>Reference URLs</TableCell>
          <TableCell>{viewData?.reference_urls }</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "bold" }}>Attachments</TableCell>
          <TableCell>{viewData?.attachments }</TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: "bold" }}>Notes</TableCell>
          <TableCell>{viewData?.notes }</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      hideBackdrop
      disableEnforceFocus
      keepMounted
      PaperProps={{
        sx: {
          position: "fixed",
          bottom: 0,
          right: 0,
          width: isEdit ? 350 : 500,
          maxHeight: "calc(100% - 150px)",
          height: "100%",
          border: "1px solid #ccc",
          p: 1,
          margin: 0,
          transition: "width 0.3s ease",
        },
      }}
    >
      <DialogTitle className="dialog-title">
        <Label
          text={isEdit ? "Edit" : "Definition"}
          color="#fff"
          fontSize="14px"
          fontWeight="500"
        />
        <BackButtons size="small" onClick={handleClose} />
      </DialogTitle>

      <DialogContent sx={{ p: 0, mt: 1 }}>
        {isEdit ? (
          <>
            <Box display="flex" mb={1} gap={1}>
              {["Defination", "Analytics", "Alerts"].map((type) => (
                <Buttons
                  key={type}
                  text={type}
                  colors={fieldType === type ? "gray" : "default"}
                  onClick={() => setFieldType(type)}
                />
              ))}
            </Box>
            {fieldType === "defination" && renderDefinationField()}
            {fieldType === "Analytics" && renderAnalyticsField()}
            {fieldType === "Alerts" && renderAlertFields()}
          </>
        ) : (
          renderViewTable()
        )}
      </DialogContent>

      <DialogActions
        sx={{ justifyContent: "flex-start", p: 1, borderTop: "1px solid #ccc" }}
      >
        {/* {isEdit ? (
          <>
            <Buttons size="small" text="Submit" onClick={handleSubmit} />
            <Buttons
              size="small"
              colors="gray"
              text="Cancel"
              onClick={() => setIsEdit(false)}
            />
          </>
        ) : (
          <>
            <Buttons
              size="small"
              colors="gray"
              text="Edit"
              onClick={() => setIsEdit(true)}
            />
            <Buttons size="small" colors="gray" text="Change History" />
          </>
        )} */}
      </DialogActions>
    </Dialog>
  );
};

export default DefinitionPopup;
